var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232,
    height: 291,
    viewBox: "0 0 232 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M121.744 121.245l108.403 155.61A9 9 0 0 1 222.762 291H9.238a9 9 0 0 1-7.385-14.144l108.403-155.611a7 7 0 0 1 11.488 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M110.256 170.22L1.853 14.61A9 9 0 0 1 9.238.465h213.524a9 9 0 0 1 7.385 14.145L121.744 170.22a7 7 0 0 1-11.488 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd591d",
    d: "M112.82 142.67L56.835 62.306A4.648 4.648 0 0 1 60.648 55h110.276a4.648 4.648 0 0 1 3.813 7.305l-55.985 80.366a3.615 3.615 0 0 1-5.932 0zM118.533 233.072l43.794 35.832a4 4 0 0 1-2.533 7.096H72.206a4 4 0 0 1-2.533-7.096l43.794-35.832a4 4 0 0 1 5.066 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.00b43fbe3ae13cdf6ecacbe0b6262192.svg";
export { ForwardRef as ReactComponent };